export const MODAL_CLOSE_TYPE = {
  DIALOG_CLOSED: 'dialogClosed',
  SUBMIT_SUCCESS: 'submitSuccess',
};
